export const COOKIE_KEY = {
  aiSearchEnabled: 'ns-ai-search-enabled',
  bffEnv: 'ns-bff-env',
  currentLanguage: '_icl_current_language',
  debugSsr: 'ns-debug-ssr',
  drawOnMap: 'ns-draw-on-map',
  evTracking: 'ev_tracking',
  labelsDisabled: 'ns-labels-disabled',
  mapDefaultToggledOn: 'ns-map-default-toggled-on',
  showWhatsAppButton: 'ns-whatsapp-enabled',
  privateOfficeAccess: 'ns-private-office-access',
  productionQueryDevtools: 'ns-production-query-devtools',
  smartSortEnabled: 'ns-smart-sort-enabled',
  chatbotEnabled: 'ns-chatbot-enabled',
  test: 'ns-ab-test', // this is only used in tests
} as const;

export type CookieKey = (typeof COOKIE_KEY)[keyof typeof COOKIE_KEY];

export const FEATURE_FLAG_COOKIE_KEY = {
  aiSearchEnabled: COOKIE_KEY.aiSearchEnabled,
  debugSsr: COOKIE_KEY.debugSsr,
  drawOnMap: COOKIE_KEY.drawOnMap,
  showWhatsAppButton: COOKIE_KEY.showWhatsAppButton,
  labelsDisabled: COOKIE_KEY.labelsDisabled,
  mapDefaultToggledOn: COOKIE_KEY.mapDefaultToggledOn,
  productionQueryDevtools: COOKIE_KEY.productionQueryDevtools,
  smartSortEnabled: COOKIE_KEY.smartSortEnabled,
  chatbotEnabled: COOKIE_KEY.chatbotEnabled,
} as const;

export type FeatureFlagCookieKey = (typeof FEATURE_FLAG_COOKIE_KEY)[keyof typeof FEATURE_FLAG_COOKIE_KEY];

export const SET_COOKIE_KEY = {
  currentLanguage: COOKIE_KEY.currentLanguage,
  labelsDisabled: COOKIE_KEY.labelsDisabled,
  privateOfficeAccess: COOKIE_KEY.privateOfficeAccess,
  smartSortEnabled: COOKIE_KEY.smartSortEnabled,
  test: COOKIE_KEY.test, // this is only used in tests
} as const;

export type SetCookieKey = (typeof SET_COOKIE_KEY)[keyof typeof SET_COOKIE_KEY];
